import { Record } from "immutable";

const Account = Record({
  name: null,
  description: null,
  photoURL: "https://aidea.biz/wp/wp-content/uploads/2019/03/logo_-white.svg?1580961248",
  notification: {
    count: null
  }
});

const state = {
  account: new Account()
}

const mutations = {
  update: (state, payload) => {
    state.account = state.account.merge(payload)
  },
  clear: (state) => {
    state.account = new Account()
  }
}

const actions = {
  update: (context, payload) => {
    context.commit("update", payload)
  },
  clear: (context) => {
    context.commit("clear")
  }
}

const getters = {
  getAccount: state => {
    return state.account;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
